import React from 'react';
import { Link } from 'react-router-dom';
import './footernavitem.css';

const FooterNavItem = (props) => {
    return ( 
        <>
        <Link to={props.footerNavItemLink} className={props.footerNavItemStyle} >
            <h3>{props.footerNavItem}</h3>
        </Link>
        </>
     );
}
 
export default FooterNavItem;